import { defineStore } from 'pinia'
import axiosService from '~/services/axios.service'
import { isSessionCurrent } from '~/utils/session'
import { useAuthStore } from './auth'

export const useConveyancingCaseStore = defineStore({
  id: 'conveyancing-case',
  state: () => ({
    conveyancingCase: {},
    caseSearches: [],
    caseSearch: null,
  }),
  actions: {
    // Answers are kept only for the session that asked: this store is persisted, and a
    // sign-out, expiry or newer sign-in during the request must not have the earlier
    // client's searches written back for the next client on this browser to read.
    async fetchCaseSearches() {
      const authStore = useAuthStore()
      const sessionHeader = authStore.authorizationHeader

      return axiosService
        .get(`/case-searches`)
        .then((response) => {
          if (!isSessionCurrent(authStore, sessionHeader)) return

          this.caseSearches = response
        })
        .catch((err) => {
          throw err
        })
    },
    async fetchCaseSearch(id) {
      const authStore = useAuthStore()
      const sessionHeader = authStore.authorizationHeader

      return axiosService
        .get(`/case-searches/${id}`)
        .then((response) => {
          if (!isSessionCurrent(authStore, sessionHeader)) return

          this.caseSearch = response
        })
        .catch((err) => {
          throw err
        })
    },
    async createPaymentIntent(id, provider = null) {
      return axiosService
        .post(`/case-searches/${id}/payments`, provider ? { provider } : {})
        .then((response) => response)
        .catch((err) => {
          throw err
        })
    },
    async createOtherPaymentIntent(data, provider = null) {
      return axiosService
        .post(`/other-payments`, provider ? { ...data, provider } : data)
        .then((response) => response)
        .catch((err) => {
          throw err
        })
    },
  },
  persist: true,
})
